import RecommendedRoutes from './RecommendedRoutes';
export default RecommendedRoutes;
